export const containerStyles = {
  outline: 'none',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  width: '100%',
  gap: '24px',
  padding: '4px',
};

export const descriptionStyles = {
  display: 'block',
};

export const sectionStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const sectionTitleStyles = {
  paddingBottom: '4px',
  borderBottom: '1px solid',
  borderColor: 'divider',
};

export const sectionDescriptionStyles = {
  display: 'block',
};

export const formGroupStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const emptyStateStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  padding: '24px',
};

export const loadingDescriptionStyles = {
  borderRadius: '4px',
};

export const loadingSectionTitleStyles = {
  borderRadius: '4px',
};

export const loadingGridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  columnGap: '12px',
  rowGap: '12px',
};

export const loadingFieldStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
};

export const loadingFieldLabelStyles = {
  borderRadius: '4px',
};

export const loadingFieldInputStyles = {
  borderRadius: '6px',
};
